import { useRef } from "react";
import { useDrag, useDrop } from "react-dnd";

const Row = ({ row, index, moveRow, dropRow, id }) => {
    const rowRef = useRef();

    const [{ handlerId }, drop] = useDrop({
        accept: "card",
        collect(monitor) {
            return {
                handlerId: monitor.getHandlerId(),
            };
        },
        hover(item) {
            if (!rowRef.current) {
                return;
            }
            const dragIndex = item.index;
            const hoverIndex = index;
            if (dragIndex === hoverIndex) {
                return;
            }
            moveRow(dragIndex, hoverIndex);
            item.index = hoverIndex;
        },
        drop(item, monitor) {
            if (!rowRef.current) {
                return;
            }
            const dropIndex = monitor.getItem();
            dropRow(dropIndex);
        },
    });

    const [{ isDragging }, drag] = useDrag({
        type: "card",
        item: () => {
            return { id, index, sort: row.original.sort };
        },
        collect: (monitor) => ({
            isDragging: monitor.isDragging(),
        }),
    });

    const opacity = isDragging ? 0 : 1;
    drag(drop(rowRef));

    return (
        <tr
            ref={rowRef}
            data-handler-id={handlerId}
            style={{ opacity, cursor: "move" }}
            key={id}
            className="w-100"
        >
            {row.cells.map((cell) => {
                return (
                    <td key={cell.id} data-testid="TableList__TD">
                        {cell.render("Cell")}
                    </td>
                );
            })}
        </tr>
    );
};

export default Row;
